import React from "react";
import { Colors } from "../../utils/colors";

interface RadioButtonProps {
  selected?: boolean;
  onChange?: () => void;
  size?: number;
  label?: string; // ⬅️ NEW
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  selected = false,
  onChange,
  size = 28,
  label,
}) => {
  return (
    <div
      onClick={onChange}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
      }}>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          border: `2px solid ${selected ? Colors.green : Colors.grey}`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        {selected && (
          <div
            style={{
              width: size / 2,
              height: size / 2,
              borderRadius: "50%",
              backgroundColor: Colors.green,
            }}
          />
        )}
      </div>

      {label && (
        <span style={{ fontSize: 14, color: Colors.black }}>{label}</span>
      )}
    </div>
  );
};
